
export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
};
